import React from 'react';
import ReactDOM from 'react-dom/client';
import '../styles/global.css';
import AppProviders from './providers/AppProviders';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AppProviders>
            <App />
        </AppProviders>
    </React.StrictMode>
);
